import { createContext, useContext } from 'react'

type NotificationPaginationState = {
  page: number
  pageSize: number
  setPage: (newPage: number) => void
  setPageSize: (newPageSize: number) => void
}

export const NotificationPaginationContext = createContext<NotificationPaginationState | null>(null)

export const useNotificationPaginationContext = () => {
  const context = useContext(NotificationPaginationContext)
  if (!context) throw new Error('useNotificationPaginationContext must be used within a NotificationPaginationContext')
  return context
}
